var _path, _polygon, _polygon2, _polygon3, _polygon4, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeometry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bec12a6a-4abf-496a-81ec-7f6ff0ed134d",
    "data-name": "adabf8a8-4cdf-4ed1-aeec-62e64e36eec2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.24,37.2a1.24,1.24,0,0,1-.62-.13L5,30.91a1.37,1.37,0,0,1-1-1.46v-17a1.78,1.78,0,0,1,1-1.48l14.65-6.3a1.16,1.16,0,0,1,1.24,0l14.68,6.3a1.59,1.59,0,0,1,1,1.48V29.53a1.6,1.6,0,0,1-1,1.49L20.86,37.2C20.61,37.07,20.37,37.2,20.24,37.2Z",
    fill: "#1a1a1a"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "20.24 35.27 5.77 29.25 5.77 12.6 20.24 18.63 20.24 35.27",
    fill: "#ccc"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "20.3 35.21 34.79 29.19 34.79 12.54 20.3 18.57 20.3 35.21",
    fill: "gray"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "20.24 18.63 34.73 12.6 20.24 6.44 5.77 12.6 20.24 18.63",
    fill: "#fff"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "17.18 31.51 8.25 27.79 8.25 17.52 17.18 21.24 17.18 31.51",
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 21.71,
    x2: 10.05,
    y2: 24.51,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 15.19,
    y1: 23.54,
    x2: 11.28,
    y2: 27.44,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeometry);
export default __webpack_public_path__ + "static/media/Geometry.45e714814b287f228bb3e61fa89ecb30.svg";
export { ForwardRef as ReactComponent };